import React from "react";
import { useNavigate } from "react-router-dom";
import PanInput from "./PanInput";
import Timeline from "./Timeline";
import Header from "./Header";
function AfterOtp() {
  const navigate = useNavigate();
  function handleClick() {
    navigate("/customer/pan");
  }

  return <PanInput />;
}
export default AfterOtp;
